import keyMirror from '../../../utilities/keymirror';

const FormNames = keyMirror({
  EDIT_SHIPPING_ADDRESS_FORM: null,
  EDIT_DISPUTE_FORM: null,
  ORDER_REFUND_FORM: null,
});

export default FormNames;
